

















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
})
export default class CollapsableMenu extends Vue {
	@Prop() public title!: string
	private show: boolean = true
}
